<template>
	<div id="app">
		<!-- <img src="./assets/logo.png" /> -->
		<router-view ref="appsRouter" v-loading="loading"/>
	</div>
</template>

<script>
import { getToken, getUserId, getCheckPlatform } from '@/utils/auth';
import { initRouterList, heartBeat } from '@/utils/permission';

export default {
	name: 'App',
	data() {
		return {
			// whiteList: ['/login', '/platformSelect'], // 白名单
			loading: false,
		};
	},
	created() {
		this.loadPermission();
		// 路由跳转时的逻辑处理
		this.$router.beforeEach((to, from, next) => {
			next();
		});
	},
	methods: {
		// 加载权限表
		loadPermission() {
				// 处理路由
				// 加载左菜单
				initRouterList();
		},
	},
	computed: {
	},
	watch: {
	}
};
</script>

<style>
#app {
	/* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
	font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #333;
	font-size: 14px;
	background: #F2F2F2;
}
.content img{
	height: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue